import { inject } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';

import { environment } from '@env/environment';
import { authConfig } from './auth.config';
import { rolesFromGroups } from './roles';
import { recordError } from '../error/diagnostics';
import { AuthState } from '../state/auth.state';
import { SessionWatcher } from './session-watcher';

interface IdentityClaims {
  sub?: string;
  preferred_username?: string;
  email?: string;
  name?: string;
  given_name?: string;
  family_name?: string;
  groups?: string[];
}

export const authInit = async (
  oauthService = inject(OAuthService),
  authState = inject(AuthState),
  sessionWatcher = inject(SessionWatcher),
): Promise<void> => {
  oauthService.configure(authConfig);
  oauthService.redirectUri = window.location.origin + window.location.pathname;

  try {
    await oauthService.loadDiscoveryDocumentAndTryLogin();
  } catch (error) {
    recordError('oidc', error);
    throw error;
  }

  oauthService.setupAutomaticSilentRefresh();
  sessionWatcher.start();

  if (!oauthService.hasValidAccessToken()) {
    return;
  }
  const claims = oauthService.getIdentityClaims() as IdentityClaims | null;
  if (!claims) {
    return;
  }
  authState.setUser({
    username: claims.preferred_username ?? claims.sub ?? '',
    email: claims.email ?? '',
    name: claims.name ?? '',
    firstName: claims.given_name,
    lastName: claims.family_name,
    roles: rolesFromGroups(claims.groups ?? [], environment.roleGroups),
  });
};
